/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateChallenge200ResponseSchema } from '../models/CreateChallenge200ResponseSchema';
import type { CreateChallengeRedeemCode200ResponseSchema } from '../models/CreateChallengeRedeemCode200ResponseSchema';
import type { CreateChallengeRedeemCodeRequestSchema } from '../models/CreateChallengeRedeemCodeRequestSchema';
import type { CreateChallengeRequestSchema } from '../models/CreateChallengeRequestSchema';
import type { DeleteSubscriptionAsTeam200ResponseSchema } from '../models/DeleteSubscriptionAsTeam200ResponseSchema';
import type { DeleteSubscriptionAsTeamRequestSchema } from '../models/DeleteSubscriptionAsTeamRequestSchema';
import type { DeleteSubscriptionAsUser200ResponseSchema } from '../models/DeleteSubscriptionAsUser200ResponseSchema';
import type { DeleteSubscriptionAsUserRequestSchema } from '../models/DeleteSubscriptionAsUserRequestSchema';
import type { GetChallenge200ResponseSchema } from '../models/GetChallenge200ResponseSchema';
import type { GetChallengeRequestSchema } from '../models/GetChallengeRequestSchema';
import type { GetChallengesAliases200ResponseSchema } from '../models/GetChallengesAliases200ResponseSchema';
import type { GetChallengeStatistics200ResponseSchema } from '../models/GetChallengeStatistics200ResponseSchema';
import type { GetChallengeStatisticsRequestSchema } from '../models/GetChallengeStatisticsRequestSchema';
import type { GetLeaderboard200ResponseSchema } from '../models/GetLeaderboard200ResponseSchema';
import type { GetLeaderboardRequestSchema } from '../models/GetLeaderboardRequestSchema';
import type { ListChallenges200ResponseSchema } from '../models/ListChallenges200ResponseSchema';
import type { ListChallengesRedeemCodes200ResponseSchema } from '../models/ListChallengesRedeemCodes200ResponseSchema';
import type { ListChallengesRedeemCodesRequestSchema } from '../models/ListChallengesRedeemCodesRequestSchema';
import type { ListChallengesRequestSchema } from '../models/ListChallengesRequestSchema';
import type { ListUserChallenges200ResponseSchema } from '../models/ListUserChallenges200ResponseSchema';
import type { ListUserChallengesRequestSchema } from '../models/ListUserChallengesRequestSchema';
import type { OkResponseSchema } from '../models/OkResponseSchema';
import type { RedeemChallenge200ResponseSchema } from '../models/RedeemChallenge200ResponseSchema';
import type { RedeemChallengeRequestSchema } from '../models/RedeemChallengeRequestSchema';
import type { SubscribeToChallengeAsTeamRequestSchema } from '../models/SubscribeToChallengeAsTeamRequestSchema';
import type { SubscribeToChallengeAsUserRequestSchema } from '../models/SubscribeToChallengeAsUserRequestSchema';
import type { UpdateChallenge200ResponseSchema } from '../models/UpdateChallenge200ResponseSchema';
import type { UpdateChallengeRedeemCode200ResponseSchema } from '../models/UpdateChallengeRedeemCode200ResponseSchema';
import type { UpdateChallengeRedeemCodeRequestSchema } from '../models/UpdateChallengeRedeemCodeRequestSchema';
import type { UpdateChallengeRequestSchema } from '../models/UpdateChallengeRequestSchema';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ChallengesService {

    /**
     * getChallenge
     * get Challenge
     * @param requestBody
     * @returns GetChallenge200ResponseSchema GetChallenge200Response
     * @throws ApiError
     */
    public static getChallenge(
        requestBody?: GetChallengeRequestSchema,
    ): CancelablePromise<GetChallenge200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/getChallenge',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `GetChallenge400Response`,
                404: `GetChallenge404Response`,
            },
        });
    }

    /**
     * listChallenges
     * list Challenges
     * @param requestBody
     * @returns ListChallenges200ResponseSchema ListChallenges200Response
     * @throws ApiError
     */
    public static listChallenges(
        requestBody?: ListChallengesRequestSchema,
    ): CancelablePromise<ListChallenges200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/listChallenges',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `ListChallenges400Response`,
            },
        });
    }

    /**
     * getLeaderboard
     * get leaderboard
     * @param requestBody
     * @returns GetLeaderboard200ResponseSchema GetLeaderboard200Response
     * @throws ApiError
     */
    public static getLeaderboard(
        requestBody?: GetLeaderboardRequestSchema,
    ): CancelablePromise<GetLeaderboard200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/getLeaderboard',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `GetLeaderboard400Response`,
                404: `GetLeaderboard404Response`,
            },
        });
    }

    /**
     * subscribeToChallengeAsTeam
     * subscribeToChallengeAsTeam
     * @param requestBody
     * @returns OkResponseSchema SubscribeToChallengeAsTeam200Response
     * @throws ApiError
     */
    public static subscribeToChallengeAsTeam(
        requestBody?: SubscribeToChallengeAsTeamRequestSchema,
    ): CancelablePromise<OkResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/subscribeToChallengeAsTeam',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `SubscribeToChallengeAsTeam400Response`,
                404: `SubscribeToChallengeAsTeam404Response`,
            },
        });
    }

    /**
     * subscribeToChallengeAsUser
     * subscribe user
     * @param requestBody
     * @returns OkResponseSchema SubscribeToChallengeAsUser200Response
     * @throws ApiError
     */
    public static subscribeToChallengeAsUser(
        requestBody?: SubscribeToChallengeAsUserRequestSchema,
    ): CancelablePromise<OkResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/subscribeToChallengeAsUser',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `SubscribeToChallengeAsUser404Response`,
            },
        });
    }

    /**
     * listUserChallenges
     * list User Challenges
     * @param requestBody
     * @returns ListUserChallenges200ResponseSchema ListUserChallenges200Response
     * @throws ApiError
     */
    public static listUserChallenges(
        requestBody?: ListUserChallengesRequestSchema,
    ): CancelablePromise<ListUserChallenges200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/listUserChallenges',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `ListUserChallenges400Response`,
            },
        });
    }

    /**
     * deleteSubscriptionAsTeam
     * deleteSubscriptionAsTeam
     * @param requestBody
     * @returns DeleteSubscriptionAsTeam200ResponseSchema DeleteSubscriptionAsTeam200Response
     * @throws ApiError
     */
    public static deleteSubscriptionAsTeam(
        requestBody?: DeleteSubscriptionAsTeamRequestSchema,
    ): CancelablePromise<DeleteSubscriptionAsTeam200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/deleteSubscriptionAsTeam',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `DeleteSubscriptionAsTeam400Response`,
                404: `DeleteSubscriptionAsTeam404Response`,
            },
        });
    }

    /**
     * deleteSubscriptionAsUser
     * deleteSubscriptionAsUser
     * @param requestBody
     * @returns DeleteSubscriptionAsUser200ResponseSchema DeleteSubscriptionAsUser200Response
     * @throws ApiError
     */
    public static deleteSubscriptionAsUser(
        requestBody?: DeleteSubscriptionAsUserRequestSchema,
    ): CancelablePromise<DeleteSubscriptionAsUser200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/deleteSubscriptionAsUser',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `DeleteSubscriptionAsUser400Response`,
                404: `DeleteSubscriptionAsUser404Response`,
            },
        });
    }

    /**
     * getChallengesAliases
     * get Challenges aliases
     * @returns GetChallengesAliases200ResponseSchema GetChallengesAliases200Response
     * @throws ApiError
     */
    public static getChallengesAliases(): CancelablePromise<GetChallengesAliases200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/getChallengesAliases',
            errors: {
                400: `GetChallengesAliases400Response`,
            },
        });
    }

    /**
     * getChallengeStatistics
     * getChallengeStatistics
     * @param requestBody
     * @returns GetChallengeStatistics200ResponseSchema GetChallengeStatistics200Response
     * @throws ApiError
     */
    public static getChallengeStatistics(
        requestBody?: GetChallengeStatisticsRequestSchema,
    ): CancelablePromise<GetChallengeStatistics200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/getChallengeStatistics',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `GetChallengeStatistics400Response`,
                404: `GetChallengeStatistics404Response`,
            },
        });
    }

    /**
     * redeemChallenge
     * redeemChallenge
     * @param requestBody
     * @returns RedeemChallenge200ResponseSchema RedeemChallenge200Response
     * @throws ApiError
     */
    public static redeemChallenge(
        requestBody?: RedeemChallengeRequestSchema,
    ): CancelablePromise<RedeemChallenge200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/redeemChallenge',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `RedeemChallenge400Response`,
                404: `RedeemChallenge404Response`,
            },
        });
    }

    /**
     * updateChallenge
     * update Challenge
     * @param requestBody
     * @returns UpdateChallenge200ResponseSchema UpdateChallenge200Response
     * @throws ApiError
     */
    public static updateChallenge(
        requestBody?: UpdateChallengeRequestSchema,
    ): CancelablePromise<UpdateChallenge200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/updateChallenge',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `UpdateChallenge400Response`,
            },
        });
    }

    /**
     * createChallenge
     * create challenge
     * @param requestBody
     * @returns CreateChallenge200ResponseSchema CreateChallenge200Response
     * @throws ApiError
     */
    public static createChallenge(
        requestBody?: CreateChallengeRequestSchema,
    ): CancelablePromise<CreateChallenge200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/createChallenge',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `CreateChallenge400Response`,
            },
        });
    }

    /**
     * listChallengesRedeemCodes
     * list Challenges redeem codes
     * @param requestBody
     * @returns ListChallengesRedeemCodes200ResponseSchema ListChallengesRedeemCodes200Response
     * @throws ApiError
     */
    public static listChallengesRedeemCodes(
        requestBody?: ListChallengesRedeemCodesRequestSchema,
    ): CancelablePromise<ListChallengesRedeemCodes200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/listChallengesRedeemCodes',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `ListChallengesRedeemCodes400Response`,
            },
        });
    }

    /**
     * updateChallengeRedeemCode
     * update challenge redeem code
     * @param requestBody
     * @returns UpdateChallengeRedeemCode200ResponseSchema UpdateChallengeRedeemCode200Response
     * @throws ApiError
     */
    public static updateChallengeRedeemCode(
        requestBody?: UpdateChallengeRedeemCodeRequestSchema,
    ): CancelablePromise<UpdateChallengeRedeemCode200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/updateChallengeRedeemCode',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `UpdateChallengeRedeemCode400Response`,
            },
        });
    }

    /**
     * createChallengeRedeemCode
     * create challenge redeem code
     * @param requestBody
     * @returns CreateChallengeRedeemCode200ResponseSchema CreateChallengeRedeemCode200Response
     * @throws ApiError
     */
    public static createChallengeRedeemCode(
        requestBody?: CreateChallengeRedeemCodeRequestSchema,
    ): CancelablePromise<CreateChallengeRedeemCode200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/createChallengeRedeemCode',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `CreateChallengeRedeemCode400Response`,
            },
        });
    }

}
